










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import GroupTestReportContent from '@/components/test_report/GroupTestReportContent.vue';

@Component({
  components: {
    Header,
    GroupTestReportContent,
    Footer,
  },
})
export default class TestReport extends Vue {}
